
import React from 'react';
import { Menu, MenuItem } from '@/types/menu';
import MenuCategoryButtons from '../navigation/MenuCategoryButtons';
import SimpleMenuCategories from '../layout/SimpleMenuCategories';
import HappyHourTimer from '../features/HappyHourTimer';
import { LanguageCode } from '@/constants/menuUITranslations';

interface MenuContentProps {
  menu: Menu;
  menuItems: MenuItem[];
  categories: string[];
  activeCategory: string | null;
  isHappyHour: boolean;
  setIsHappyHour: (value: boolean) => void;
  onCategoryChange: (category: string) => void;
  currentLanguage?: LanguageCode;
}

const MenuContent: React.FC<MenuContentProps> = ({
  menu,
  menuItems,
  categories,
  activeCategory,
  isHappyHour,
  setIsHappyHour,
  onCategoryChange,
  currentLanguage = 'fr'
}) => {
  return (
    <div className="space-y-6">
      <div className="px-4 space-y-4 lg:px-0">
        {menu?.custom_css?.happyHourSchedule?.enabled && (
          <HappyHourTimer 
            schedule={menu.custom_css.happyHourSchedule}
            setIsHappyHour={setIsHappyHour}
            primaryColor={menu.primary_color || '#F97316'}
            themeColor={menu.primary_color || '#F97316'}
            fontFamily={menu.font_family || 'Inter, sans-serif'}
            isHappyHour={isHappyHour}
            currentLanguage={currentLanguage}
          />
        )}
      </div>
      
      <div className="lg:px-0">
        <MenuCategoryButtons
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={onCategoryChange}
          menu={menu}
        />
      </div>
      
      <div className="lg:px-0">
        <SimpleMenuCategories 
          menuItems={menuItems} 
          categories={categories}
          activeCategory={activeCategory}
          menu={menu}
          isHappyHour={isHappyHour}
          currentLanguage={currentLanguage}
        />
      </div>
    </div>
  );
};

export default MenuContent;
